<section class="expense-workflow-deprecation">
    <app-page-data-panel
        title="Legacy Expense Workflow"
        subtitle="Expense approvals are now configured in the shared workflow engine, not in this legacy step editor."
        resultText="Deprecated">
        <div actions class="expense-workflow-deprecation__actions">
            <a
                pButton
                routerLink="/workflow/config"
                [queryParams]="workflowEngineParams"
                icon="pi pi-sitemap"
                label="Open Workflow Engine"></a>
            <a
                pButton
                routerLink="/expense"
                severity="secondary"
                [outlined]="true"
                icon="pi pi-arrow-left"
                label="Back to Expenses"></a>
        </div>

        <div class="expense-workflow-deprecation__hero">
            <p-tag value="Deprecated" severity="warn"></p-tag>
            <p>
                The old expense approval step list has been retired. Use the shared workflow engine so expense approvals
                follow the same state, action, and rule model used across the platform.
            </p>
        </div>

        <div class="expense-workflow-deprecation__grid">
            <article class="expense-workflow-deprecation__card">
                <h3>What changed</h3>
                <ul>
                    <li>Expense approval configuration moved to the shared workflow engine.</li>
                    <li>States, actions, reopen paths, and validation rules are now managed in one internal tool.</li>
                    <li>This page remains only as a compatibility handoff for existing bookmarks and menu history.</li>
                </ul>
            </article>

            <article class="expense-workflow-deprecation__card">
                <h3>Use this instead</h3>
                <ul>
                    <li>Open <strong>Workflow Engine</strong> with the <strong>EXPENSE</strong> resource preselected.</li>
                    <li>Edit steps, action buttons, role restrictions, and rule JSON from the inspector.</li>
                    <li>Keep expense approvals aligned with the wider app-wide workflow model.</li>
                </ul>
            </article>
        </div>
    </app-page-data-panel>
</section>
